import { setSearchTerm } from '../State/searchTerm';

export default (e) => async (dispatch) => {
  dispatch(setSearchTerm(e.target.value));
}
